import * as yup from 'yup';

const requiredMessage = () => `Поле является обязательным`;

const validationSchema = yup.object().shape({
  uid: yup.string().required(requiredMessage),
  start: yup.date().required(requiredMessage),
});
export { validationSchema };
